import { Navigate, useLocation } from "react-router-dom";
import HeaderBackground from "./HeaderBackground";
import background from './img/BANNER.png';
import { getRootLocation } from "./util/Util";
import { useMemo } from "react";

function Home() {
    const location = useLocation();

    const redirectTo = useMemo(() => new URLSearchParams(location.search).get('redirectTo'), [location]);

    if (redirectTo) {
      return <Navigate to={redirectTo} replace />
    }
    if (true) {
        return <Navigate to={getRootLocation() + "games"} replace />
    }
    return <div>
        <HeaderBackground background={background} />
    </div>
}

export default Home;